import React from 'react'
import HardHeader from './HardHeader'
import HardFooter from './HardFooter'
import HardBody from './HardBody'
const HardGame = () => {
  return (
    <div>
      <HardHeader />
        <HardBody />
        <HardFooter />
    </div>
  )
}

export default HardGame
